module.exports = __webpack_public_path__ + "media/src/images/icons/trash-3613afc0a7105f3c445c7733abdedc63.svg";